import { render, staticRenderFns } from "./AgroGenericCard.vue?vue&type=template&id=c3024f14&scoped=true&"
import script from "./AgroGenericCard.vue?vue&type=script&lang=ts&"
export * from "./AgroGenericCard.vue?vue&type=script&lang=ts&"
import style0 from "./agro-generic-card.scss?vue&type=style&index=0&id=c3024f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3024f14",
  null
  
)

export default component.exports